var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.reRender,
      staticClass: "d-flex justify-content-center flex-wrap question-screen",
    },
    [
      _vm.exam && !_vm.userExam.startedAt
        ? _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-alert", { attrs: { value: true, type: "warning" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("question.warning_start_exam", {
                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                      })
                    ) +
                    "\n    "
                ),
              ]),
            ],
            1
          )
        : _vm.exam && _vm.userExam.questions && _vm.userExam.startedAt
        ? _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              !_vm.mobile
                ? _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pe-1", attrs: { xs7: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "question-card" },
                            [
                              _c(
                                "v-card-title",
                                { attrs: { "primary-title": "" } },
                                [
                                  _vm.groupQuestion.isDescriptionQuestion
                                    ? [
                                        _c("p", { staticClass: "title m-0" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("question.description", {
                                                  format:
                                                    _vm.LETTER_FORMAT
                                                      .UPTITLECASE,
                                                })
                                              ) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    : _vm.exam.autoDiagnosisEnabled
                                    ? [
                                        _c("p", { staticClass: "title m-0" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("question.problem", {
                                                  format:
                                                    _vm.LETTER_FORMAT
                                                      .UPTITLECASE,
                                                }) +
                                                  " " +
                                                  _vm.questionNumber
                                              ) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _vm.isReport
                                          ? _c(
                                              "p",
                                              { staticClass: "title m-0" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "question.completion_status",
                                                        {
                                                          format:
                                                            _vm.LETTER_FORMAT
                                                              .UPTITLECASE,
                                                        }
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "p",
                                              { staticClass: "title m-0" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "question.problem",
                                                        {
                                                          format:
                                                            _vm.LETTER_FORMAT
                                                              .UPTITLECASE,
                                                        }
                                                      ) +
                                                        " " +
                                                        _vm.questionNumber
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _vm.groupQuestion.isWorkSheet
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass: "ms-2",
                                                attrs: {
                                                  color: "orange",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "question.work_sheet"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                                _c(
                                                  "v-icon",
                                                  { attrs: { right: "" } },
                                                  [_vm._v("star")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isExamResultAfterQuestion
                                          ? [
                                              _vm.userScore == _vm.maxScore
                                                ? [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "title m-0 result-success",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color:
                                                                "rgb(4, 4, 241)",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-circle-outline"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "正解です (" +
                                                            _vm._s(
                                                              _vm.maxScore
                                                            ) +
                                                            "点)\n                  "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm.userScore == 0
                                                ? [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "title m-0 result-failed",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color:
                                                                "rgb(223, 12, 12)",
                                                            },
                                                          },
                                                          [_vm._v("close")]
                                                        ),
                                                        _vm._v(
                                                          "不正解です (0点)\n                  "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "title m-0 result-not-full",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color:
                                                                "rgb(1, 156, 1)",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-triangle-outline"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getRateScore(
                                                              _vm.userScore,
                                                              _vm.maxScore
                                                            )
                                                          ) +
                                                            "% 正解です (" +
                                                            _vm._s(
                                                              _vm.userScore
                                                            ) +
                                                            "/" +
                                                            _vm._s(
                                                              _vm.maxScore
                                                            ) +
                                                            "点)\n                  "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                            ]
                                          : _vm._e(),
                                      ],
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c("ExamTimer", {
                                    attrs: {
                                      time: _vm.time,
                                      timeLimit: _vm.exam.timeLimit,
                                      "start-time":
                                        _vm.userExam.startedAt.toISOString(),
                                    },
                                    on: { "time-up": _vm.handleTimeUp },
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { light: "" } }),
                              _vm._v(" "),
                              _vm.isReport
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "question-container test-main report-for-exam",
                                      },
                                      [
                                        _c(
                                          "v-card-title",
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-12 p-0" },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "m-0" },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "question.response",
                                                            {
                                                              format:
                                                                _vm
                                                                  .LETTER_FORMAT
                                                                  .UPFIRSTCASE,
                                                            }
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-lg-12 p-0 mt-2 mb-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "progress-answer",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          Math.round(
                                                            (_vm
                                                              .examTestQuestionsAnswered
                                                              .length *
                                                              100) /
                                                              _vm.exam
                                                                .questionsIgnoreDescription
                                                                .length
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "question.progress",
                                                          {
                                                            format:
                                                              _vm.LETTER_FORMAT
                                                                .UPFIRSTCASE,
                                                          }
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.examTestQuestionsAnswered
                                              .length !=
                                            _vm.exam.questionsIgnoreDescription
                                              .length
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-12 p-0",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "m-0" },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "question.not_done",
                                                                  {
                                                                    format:
                                                                      _vm
                                                                        .LETTER_FORMAT
                                                                        .UPFIRSTCASE,
                                                                  }
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-lg-12 p-0",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "m-0" },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "question.done",
                                                                  {
                                                                    format:
                                                                      _vm
                                                                        .LETTER_FORMAT
                                                                        .UPFIRSTCASE,
                                                                  }
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-lg-12 p-0",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "m-0" },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "question.done",
                                                                {
                                                                  format:
                                                                    _vm
                                                                      .LETTER_FORMAT
                                                                      .UPFIRSTCASE,
                                                                }
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", { attrs: { light: "" } }),
                                  ]
                                : [
                                    _vm.isExamResultAfterQuestion
                                      ? _c(
                                          "v-container",
                                          {
                                            staticClass:
                                              "question-container test-main p-2",
                                            attrs: {
                                              fluid: "",
                                              "grid-list-lg": "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                staticClass: "result-title",
                                                attrs: { row: "", wrap: "" },
                                              },
                                              [
                                                _vm._l(
                                                  _vm.groupQuestion.questions,
                                                  function (item, index) {
                                                    return [
                                                      _c(
                                                        "ExamResultQuestionBodyWeb",
                                                        {
                                                          key: index,
                                                          ref:
                                                            "question_" +
                                                            item.id,
                                                          refInFor: true,
                                                          attrs: {
                                                            id:
                                                              "question_" +
                                                              item.id,
                                                            groupIndex:
                                                              _vm.groupIndex +
                                                              1,
                                                            currentQuestion:
                                                              item,
                                                            index: index + 1,
                                                            isMultipleQuestion:
                                                              _vm.groupQuestion
                                                                .questions
                                                                .length > 1,
                                                            schoolSetting:
                                                              _vm.schoolSetting,
                                                            exam: _vm.exam,
                                                            "user-exam":
                                                              _vm.userExam,
                                                          },
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        key: "divider" + index,
                                                        staticClass: "divider",
                                                      }),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm.groupQuestion
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "question-container test-main",
                                          },
                                          [
                                            _vm._l(
                                              _vm.groupQuestion.questions,
                                              function (item, index) {
                                                return [
                                                  _c(
                                                    "ExamTestQuestionBodyWeb",
                                                    {
                                                      key: index,
                                                      ref:
                                                        "question_" + item.id,
                                                      refInFor: true,
                                                      attrs: {
                                                        exam: _vm.exam,
                                                        id:
                                                          "question_" + item.id,
                                                        currentQuestion: item,
                                                        index: index,
                                                        time: _vm.time,
                                                      },
                                                      on: {
                                                        changeValue:
                                                          _vm.callBackChange,
                                                      },
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.groupQuestion.questions &&
                                                  _vm.groupQuestion.questions
                                                    .length > 1
                                                    ? _c("div", {
                                                        key: "divider" + index,
                                                        staticClass: "divider",
                                                      })
                                                    : _vm._e(),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                { staticClass: "answer-footer" },
                                [
                                  _c("ChartProgress", {
                                    key:
                                      _vm.examTestQuestionsAnswered.length /
                                      _vm.exam.questionsIgnoreDescription
                                        .length,
                                    attrs: {
                                      size: 160,
                                      series: [
                                        (_vm.examTestQuestionsAnswered.length *
                                          100) /
                                          _vm.exam.questionsIgnoreDescription
                                            .length,
                                      ],
                                      labelColor: "#2699fb",
                                      label:
                                        _vm.examTestQuestionsAnswered.length +
                                        "/" +
                                        _vm.exam.questionsIgnoreDescription
                                          .length,
                                      subLabel: _vm.$t("question.question", {
                                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                                      }),
                                      chartColor: "#2699fb",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { light: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                { staticClass: "footer-card-question p-3" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "justify-content-center": "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            disabled: _vm.isFirstItem,
                                          },
                                          on: { click: _vm.first },
                                        },
                                        [
                                          _vm._v(
                                            "\n                最初\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            disabled: _vm.isFirstItem,
                                          },
                                          on: { click: _vm.previous },
                                        },
                                        [
                                          _vm._v(
                                            "\n                前へ\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "m-1 green-color",
                                          attrs: {
                                            rounded: "",
                                            color: "white",
                                            light: "",
                                            cytag: "center-click",
                                          },
                                          on: {
                                            click: _vm.buttonHandler.action,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.buttonHandler.label) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            disabled: _vm.isLastItem,
                                          },
                                          on: { click: _vm.next },
                                        },
                                        [
                                          _vm._v(
                                            "\n                次へ\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            disabled: _vm.isReport,
                                          },
                                          on: { click: _vm.last },
                                        },
                                        [
                                          _vm._v(
                                            "\n                最後\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "ps-1", attrs: { xs5: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "question-card" },
                            [
                              _c(
                                "v-card-title",
                                { attrs: { "primary-title": "" } },
                                [
                                  _c("p", { staticClass: "title m-0" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("question.answer_number", {
                                            format:
                                              _vm.LETTER_FORMAT.UPTITLECASE,
                                          })
                                        ) +
                                        "\n              " +
                                        _vm._s(
                                          _vm.examTestQuestionsAnswered.length +
                                            "/" +
                                            _vm.exam.questionsIgnoreDescription
                                              .length
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { light: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "question-list-show",
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        { staticClass: "question-list-block" },
                                        [
                                          _vm._l(
                                            _vm.groupExamTestQuestions,
                                            function (
                                              groupExamTestQuestion,
                                              index
                                            ) {
                                              return [
                                                _c("QuestionGroupTestList", {
                                                  key: index + "group",
                                                  attrs: {
                                                    groupExamTestQuestion:
                                                      groupExamTestQuestion,
                                                    questionNumber:
                                                      _vm.getQuestionNumber(
                                                        groupExamTestQuestion
                                                      ),
                                                    groupQuestions:
                                                      _vm.groupQuestions,
                                                    isExamResultAfterQuestion:
                                                      _vm.exam
                                                        .isResultAfterQuestion,
                                                    active:
                                                      !_vm.isReport &&
                                                      groupExamTestQuestion.groupId ==
                                                        _vm.groupQuestion
                                                          .groupId,
                                                    padding: true,
                                                    exam: _vm.exam,
                                                  },
                                                  on: { click: _vm.goQuestion },
                                                }),
                                                _vm._v(" "),
                                                index + 1 <
                                                groupExamTestQuestion.questions
                                                  .length
                                                  ? _c("v-divider", {
                                                      key:
                                                        index + "group_divider",
                                                    })
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { light: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                { staticClass: "footer-card-report p-3" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "justify-content-center": "" } },
                                    [
                                      _c(
                                        "v-dialog",
                                        {
                                          attrs: { width: "500" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "m-1 orange-color",
                                                          attrs: {
                                                            rounded: "",
                                                            color: "white",
                                                            light: "",
                                                            cytag: "submit",
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.submit",
                                                                {
                                                                  format:
                                                                    _vm
                                                                      .LETTER_FORMAT
                                                                      .UPTITLECASE,
                                                                }
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            549471074
                                          ),
                                          model: {
                                            value: _vm.confimDialog,
                                            callback: function ($$v) {
                                              _vm.confimDialog = $$v
                                            },
                                            expression: "confimDialog",
                                          },
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-title",
                                                {
                                                  staticClass:
                                                    "headline grey lighten-2",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    本当に提出してよろしいですか？\n                  "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-actions",
                                                [
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        text: "",
                                                        cytag: "confirm-submit",
                                                      },
                                                      on: {
                                                        click: _vm.confimSubmit,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.submit",
                                                              {
                                                                format:
                                                                  _vm
                                                                    .LETTER_FORMAT
                                                                    .UPTITLECASE,
                                                              }
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-layout",
                    { staticClass: "bg-white", attrs: { column: "" } },
                    [
                      _c(
                        "swipe",
                        {
                          ref: "swipe",
                          staticClass: "my-swipe",
                          attrs: {
                            auto: 0,
                            speed: 100,
                            showIndicators: false,
                            defaultIndex: 1,
                            disabled: true,
                          },
                          on: { change: _vm.changeQuestion },
                        },
                        [
                          _c("swipe-item", { staticClass: "slide1" }),
                          _vm._v(" "),
                          _c(
                            "swipe-item",
                            { staticClass: "slide2" },
                            [
                              _vm.isExamResultAfterQuestion
                                ? _vm._l(
                                    _vm.groupQuestion.questions,
                                    function (item, index) {
                                      return _c(
                                        "ExamResultQuestionBodyMobile",
                                        {
                                          key: index,
                                          ref: "question_" + item.id,
                                          refInFor: true,
                                          attrs: {
                                            id: "question_" + item.id,
                                            groupIndex: _vm.groupIndex + 1,
                                            currentQuestion: item,
                                            index: index + 1,
                                            isMultipleQuestion:
                                              _vm.groupQuestion.questions
                                                .length > 1,
                                            schoolSetting: _vm.schoolSetting,
                                            exam: _vm.exam,
                                            "user-exam": _vm.userExam,
                                          },
                                        }
                                      )
                                    }
                                  )
                                : _vm._l(
                                    _vm.groupQuestion.questions,
                                    function (item, index) {
                                      return _c("ExamTestQuestionBodyMobile", {
                                        key: index,
                                        ref: "question_" + item.id,
                                        refInFor: true,
                                        attrs: {
                                          exam: _vm.exam,
                                          id: "question_" + item.id,
                                          currentQuestion: item,
                                          index: index,
                                          time: _vm.time,
                                        },
                                        on: { changeValue: _vm.callBackChange },
                                      })
                                    }
                                  ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("swipe-item", { staticClass: "slide3" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": "290" },
                  model: {
                    value: _vm.timeOut,
                    callback: function ($$v) {
                      _vm.timeOut = $$v
                    },
                    expression: "timeOut",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-text", [_vm._v("時間切れになりました")]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: { click: _vm.showResult },
                            },
                            [_vm._v("提出")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("portal", { attrs: { to: "header-left" } }, [
        _c(
          "div",
          { staticClass: "d-flex align-center minus-left" },
          [
            _c(
              "v-btn",
              {
                staticClass: "mk-0",
                attrs: { icon: "" },
                on: { click: _vm.toExamShow },
              },
              [_c("v-icon", [_vm._v("keyboard_arrow_left")])],
              1
            ),
            _vm._v(" "),
            _c(
              "v-toolbar-title",
              {
                class: { "ps-0": _vm.mobile },
                style: { color: _vm.headerNavTextColor },
              },
              [_vm._v("\n        " + _vm._s(_vm.headerTitle) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.exam && _vm.mobile
        ? _c("portal", { attrs: { to: "header-right" } }, [
            _c(
              "div",
              { staticClass: "d-flex align-center minus-right" },
              [
                _c("ExamTimer", {
                  attrs: {
                    time: _vm.time,
                    timeLimit: _vm.exam.timeLimit,
                    "start-time": _vm.userExam.startedAt.toISOString(),
                  },
                  on: { "time-up": _vm.handleTimeUp },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toExamQuestionList.apply(null, arguments)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("menu")])],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.exam && _vm.mobile
        ? _c("portal", { attrs: { to: "header-right-drawer" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.exam && _vm.mobile
        ? _c(
            "portal",
            { attrs: { to: "header-center" } },
            [!_vm.mobile ? _c("HeaderUser") : _vm._e()],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }